/**
 * Ordenação para flush: priority → sessionSequence → occurredAt.
 */

import type { QueueItem, QueuePriority } from '../queue';
import { recordOrderingInversion } from '../telemetry';

const PRIORITY_ORDER: QueuePriority[] = ['high', 'medium', 'low'];

function priorityRank(p: QueuePriority): number {
  const i = PRIORITY_ORDER.indexOf(p);
  return i >= 0 ? i : 99;
}

export function compareQueueItemsOrdered(a: QueueItem, b: QueueItem): number {
  const pa = priorityRank(a.priority);
  const pb = priorityRank(b.priority);
  if (pa !== pb) return pa - pb;
  const sa = a.sessionSequence ?? 0;
  const sb = b.sessionSequence ?? 0;
  if (sa !== sb) return sa - sb;
  const oa = a.occurredAt ?? a.createdAt;
  const ob = b.occurredAt ?? b.createdAt;
  if (oa !== ob) return oa - ob;
  return a.createdAt - b.createdAt;
}

export function sortQueueForReplay(items: QueueItem[]): QueueItem[] {
  let inversions = 0;
  const sorted = [...items].sort(compareQueueItemsOrdered);
  for (let i = 1; i < sorted.length; i++) {
    if (compareQueueItemsOrdered(sorted[i - 1], sorted[i]) > 0) inversions++;
  }
  if (inversions > 0) recordOrderingInversion(inversions);
  return sorted;
}
